<template>
  <div class="main-content bg-default">
    <!-- Navbar -->
    <base-nav
      class="navbar-top navbar-horizontal navbar-dark"
      containerClasses="px-4 container"
      expand
    >
      <!-- <router-link slot="brand" class="navbar-brand" to="/">
                <img src="static/img/brand/white.png"/>
            </router-link> -->

      <template v-slot="{ closeMenu }">
        <!-- Collapse header -->
        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-6 collapse-brand">
              <router-link to="/">
                <img src="static/img/brand/green.png" />
              </router-link>
            </div>
            <div class="col-6 collapse-close">
              <button
                type="button"
                @click="closeMenu"
                class="navbar-toggler"
                aria-label="Toggle sidenav"
              >
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        </div>
        <!-- Navbar items -->
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <router-link class="nav-link nav-link-icon" to="/register">
              <i class="ni ni-circle-08"></i>
              <span class="nav-link-inner--text">{{$t('common.authNavBarRegister')}}</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link nav-link-icon" to="/login">
              <i class="ni ni-key-25"></i>
              <span class="nav-link-inner--text">{{$t('common.authNavBarLogin')}}</span>
            </router-link>
          </li>
          <li class="nav-item">
            <button v-for="entry in languages" :key="entry.title" @click="changeLocale(entry.language)">
              <flag :iso="entry.flag" v-bind:squared=false /> {{entry.title}}
            </button>
          </li>
        </ul>
      </template>
    </base-nav>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-lg-5 col-md-6">
              <h1 class="text-white">{{ $t('login.welcomeMsg') }}</h1>
              <!-- <p class="text-lead text-white">
                Use these awesome forms to login or create new account in your
                project for free.
              </p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <router-view></router-view>
    </div>
    <footer class="py-5">
      <div class="container">
        <div class="row align-items-center justify-content-xl-between">
          <div class="col-xl-6">
            <div class="copyright text-center text-xl-left text-muted">
              &copy; {{ year }}
              <a
                href="http://www.agroupadvisor.com"
                class="font-weight-bold ml-1"
                target="_blank"
                >AgroUPAdvisor</a
              >
            </div>
          </div>
          <div class="col-xl-6">
            <ul
              class="nav nav-footer justify-content-center justify-content-xl-end"
            >
              <li class="nav-item">
                <a
                  href="http://www.agroupadvisor.com"
                  class="nav-link"
                  target="_blank"
                  style="color: wheat"
                  >AgroUPAdvisor <span class="version">v{{ projectVersion }}</span></a
                >
                
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import i18n from '@/contents/contents'

export default {
  name: "auth-layout",
  methods: {
    changeLocale(locale) {
        i18n.global.locale = locale;
    }
  },
  data() {
    return {
      year: new Date().getFullYear(),
      showMenu: false,
      projectVersion: process.env.VUE_APP_PROJECT_VERSION,
      languages: [
            { flag: 'us', language: 'en' },
            { flag: 'es', language: 'es' },
            { flag: 'es-ct', language: 'cat'}
        ]
    };
  },
};
</script>
<style scoped>
button {
    height: 100%;
    background-color: Transparent;
    background-repeat:no-repeat;
    border: none;
    cursor:pointer;
    overflow: hidden;
    outline:none;
}

.version{
  padding-left: 5px;
  color: wheat;
}
</style>
